"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LootboxRedemptionToJSON = exports.LootboxRedemptionFromJSONTyped = exports.LootboxRedemptionFromJSON = void 0;
var runtime_1 = require("../runtime");
function LootboxRedemptionFromJSON(json) {
    return LootboxRedemptionFromJSONTyped(json, false);
}
exports.LootboxRedemptionFromJSON = LootboxRedemptionFromJSON;
function LootboxRedemptionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'lootboxName': json['lootboxName'],
        'prizeRevealName': json['prizeRevealName'],
        'transactionHash': !(0, runtime_1.exists)(json, 'transactionHash') ? undefined : json['transactionHash'],
        'promoCode': !(0, runtime_1.exists)(json, 'promoCode') ? undefined : json['promoCode'],
        'createdAt': json['createdAt'],
    };
}
exports.LootboxRedemptionFromJSONTyped = LootboxRedemptionFromJSONTyped;
function LootboxRedemptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'lootboxName': value.lootboxName,
        'prizeRevealName': value.prizeRevealName,
        'transactionHash': value.transactionHash,
        'promoCode': value.promoCode,
        'createdAt': value.createdAt,
    };
}
exports.LootboxRedemptionToJSON = LootboxRedemptionToJSON;
